import React, {useEffect, useState} from "react";
import http from "../framework/http";
import {Link} from "react-router-dom";

function Blogs() {
    const [blogs, setBlogs] = useState();

    useEffect(() => {
        loadBlog();
    }, []);

    async function loadBlog(keyword) {
        const res = await http.get("/blog/list", {params: {keyword: keyword}});
        if (res.data?.code === 200) {
            setBlogs(res.data.data);
            console.log(res.data.data)
        }
    }

    return (
        <div className="blog-list-container">
            <div className="blog-list-header">
                <h1 className="blog-list-title">Blogs</h1>
            </div>
            
            <div className="blog-grid">
                {blogs?.map(item => (
                    <Link to={`/blogs/${item.id}`} key={item.id} className="blog-card-link">
                        <article className="blog-card">
                            <div className="blog-card-image">
                                <img 
                                    src={item.cover ?
                                        http.getUri() + item.cover :
                                        http.getUri() + "images/default.png"} 
                                    alt={item.title}
                                />
                            </div>
                            <div className="blog-card-content">
                                <h3 className="blog-card-title">{item.title}</h3>
                                <div className="blog-card-meta">
                                    <time className="blog-card-date">
                                        {new Date(item.createdTime).toLocaleDateString('en-US', { 
                                            year: 'numeric', 
                                            month: 'short', 
                                            day: 'numeric' 
                                        })}
                                    </time>
                                </div>
                                {item.summary && (
                                    <p className="blog-card-excerpt">{item.summary}</p>
                                )}
                                <div className="blog-card-footer">
                                    <span className="blog-card-readmore">Continue Reading</span>
                                </div>
                            </div>
                        </article>
                    </Link>
                ))}
            </div>
        </div>
    );
}

export default Blogs;
